<template lang="pug">
    .image(v-bind:style="{width: image.width + 'px'}" :class="{ small }")
        //- v-lazy="image"
        img(
            :src="image.src"
            @mouseover.prevent.stop="focus"
            @mouseleave.prevent.stop="leave"
        )
</template>
<script>
//import Components
import { cloneDeep } from 'lodash'
import { mapMutations } from 'vuex'
export default {
    name: "PreviewImage",
    props: {
        media: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        image(){
            let image = cloneDeep(this.media.image)

            let width = image.width
            let height = image.height

            const aspectRatio = width / height
            let maxHeight = 200
            if (this.small) maxHeight = 100

            if (height > maxHeight) {
                height = maxHeight
                width = height * aspectRatio
            }

            let root = '';
            const endpoint = process.env.VUE_APP_API_ENDPOINT
            if ( process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE ) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE
            const base =  endpoint + root + 'images/'

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            let w = width
            let h = height
            if (window.devicePixelRatio) {
                w = width * window.devicePixelRatio;
                h = height * window.devicePixelRatio;
            }

            return {
                cdn: image.url,
                src: `${base}${image.id}/${image.name}?fit&h=${h}${format}`,
                error: `${base}${image.id}/${image.name}?fit&h=${h}&preview=greyscale`,
                loading: `${base}${image.id}/${image.name}?fit&h=${h}&preview=blur`,
                width,
                height,
                aspectRatio
            }
        }
    },
    methods: {
        focus() {
            this.setFocusedMedia({ product: this.product, media: this.media })
        },
        leave() {
            this.removeFocusedMedia()
        },
        ...mapMutations({
            setFocusedMedia: 'shop/setFocusedMedia',
            removeFocusedMedia: 'shop/removeFocusedMedia',
            webpSupport: 'webpSupport'
        }),
    }
}
</script>
<style lang="sass" scoped>
.image
    // margin: 0 10px 0 0
    margin: 5px
    height: 201px
    border: 1px solid #000
    background-color: #dedede
    overflow: hidden
    float: left
    img
        max-height: 200px
        width: 100%
        height: 100%
        object-fit: cover
        overflow: hidden
    &.small
        height: 101px
        img
            max-height: 100px
</style>
